import apiRequest from './apiRequest';

/** Keep in sync with user-api `userApiService` Stytch sentinel IDs. */
export const MANUAL_ORG_CREATION_STYTCH_ID = 'manual-org-creation';
export const SELF_SERVICE_CREATION_STYTCH_ID = 'self-service-org';

export type AdminUserManagementOrganizationSummary = {
  organizationID: string;
  organizationName: string;
  createdAt: string;
  createdBy: string;
  accessLevel?: string;
};

export default async function getAdminUserManagementOrganizations(
  options?: {
    limit?: number;
    nextToken?: string;
    stytchID?: string;
  },
) {
  const params = new URLSearchParams();
  if (options?.stytchID) params.set('stytchID', options.stytchID);
  if (options?.limit != null) params.set('limit', String(options.limit));
  if (options?.nextToken) params.set('nextToken', options.nextToken);
  const query = params.toString();
  const url = query
    ? `/admin/userManagement/organizations?${query}`
    : '/admin/userManagement/organizations';
  return apiRequest<{
    nextToken?: string;
    organizations: AdminUserManagementOrganizationSummary[];
  }>('user', url);
}
